import React from "react";
import { REFUND_STATUS_CODE, RefundRequest } from "types/refund";
import RefundItem from "features/refund/refund-item/RefundItem";
import SkeletonRefundItem from "features/refund/refund-item/SkeletonRefundItem";
import "./refund-list.css";

interface Props {
  refunds: RefundRequest[];
  loading: boolean;
  processingId: string | null;
  /** Only for a row the backend could not tag; each row still prefers its own symbol. */
  fallbackTokenSymbol: string;
  onRefresh: () => void;
  onSettle: (requestId: string, merchantId: string, cardNumber: string) => void;
  onReject: (requestId: string, merchantId: string, cardNumber: string) => void;
}

function RefundList({
  refunds,
  loading,
  processingId,
  fallbackTokenSymbol,
  onRefresh,
  onSettle,
  onReject,
}: Props) {
  return (
    <section className="rf-list">
      <div className="rf-list__header">
        <div className="rf-list__title-wrap">
          <h3 className="rf-list__title">Recent Refunds</h3>
          {refunds.filter((r) => r.status === REFUND_STATUS_CODE.PENDING)
            .length > 0 && (
            <span className="rf-list__count">
              {
                refunds.filter((r) => r.status === REFUND_STATUS_CODE.PENDING)
                  .length
              }
            </span>
          )}
        </div>
        {/* <button
          className={`v1-ico-btn${loading ? " rf-list__refresh--spinning" : ""}`}
          onClick={onRefresh}
          disabled={loading}
          aria-label="Refresh returns"
        >
          <RefreshIconV1 size={16} />
        </button> */}
      </div>

      {loading && refunds.length === 0 ? (
        <div className="rf-list__items">
          {Array.from({ length: 2 }, (_, i) => (
            <SkeletonRefundItem key={i} />
          ))}
        </div>
      ) : refunds.length === 0 ? (
        <div className="rf-list__empty">No pending returns.</div>
      ) : (
        <div className="rf-list__items">
          {refunds.map((r) => (
            <RefundItem
              key={r.id}
              request={r}
              fallbackTokenSymbol={fallbackTokenSymbol}
              onSettle={onSettle}
              onReject={onReject}
              isProcessing={processingId === r.id}
            />
          ))}
        </div>
      )}
    </section>
  );
}

export default RefundList;
